import React from 'react';
import {Field} from 'redux-form/immutable';
import {Card} from 'antd';
import {SelectField, TextField}from 'redux-form-antd';
import {
    required, nullValue1,
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const AccountInformationData = props => {
    const life_death_select = [
        {
            label: '-- 請選擇 --',
            value: '-1'
        },
        {
            label: '存',
            value: '1'
        },
        {
            label: '歿',
            value: '2'
        },
    ]
    return (
        <Card title="戶口資料">
            <Field {...formItemLayout} validate={[required]} component={TextField} label="住家電話"
                   name="stud_tel_1" type="text" ></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="父親姓名"
                   name="fath_name" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="父親身分證字號"
                   name="fath_person_id" type="text"></Field>
            <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label="父親存歿"
                   options={life_death_select} name="fath_alive" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="父親出生年次"
                   name="fath_birthyear" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="父親公司電話"
                   name="fath_phone" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="父親行動電話"
                   name="fath_hand_phone" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="父親教育程度"
                   name="fath_education" type="text" ></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="父親職業"
                   name="fath_occupation" type="text" ></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="父親服務單位"
                   name="fath_unit" type="text" ></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="父親職稱"
                   name="fath_work_name" type="text" ></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="父親電子信箱"
                   name="fath_email" type="text" ></Field>


            <Field {...formItemLayout} validate={[required]} component={TextField} label="母親姓名"
                   name="moth_name" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="母親身分證字號"
                   name="moth_person_id" type="text"></Field>
            <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label="母親存歿"
                   options={life_death_select} name="moth_alive" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="母親出生年次"
                   name="moth_birthyear" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="母親公司電話"
                   name="moth_phone" type="text" ></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="母親行動電話"
                   name="moth_hand_phone" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="母親教育程度"
                   name="moth_education" type="text" ></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="母親職業"
                   name="moth_occupation" type="text" ></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="母親服務單位"
                   name="moth_unit" type="text" ></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="母親職稱"
                   name="moth_work_name" type="text" ></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="母親電子信箱"
                   name="moth_email" type="text" ></Field>
        </Card>
    )
}
// export default TransferStudent
export default AccountInformationData



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/AccountInformationData.jsx